import { NUMBER_OF_ARTICLES_ON_PAGE } from "../HistoriografijaConstants"
import { addAuthorizationToHeaders } from "./CommonService"
import { getLocalStorage } from "./StorageHelper"
import noRefreshClient from "./api/NoRefreshClient"
import refreshClient, { handleErrors } from "./api/RefreshClient"

export async function fetchLastArticles(limit) {
    return noRefreshClient.get("articles?limit=" + parseInt(limit))
      .then(data => {
          return data.data
      })
      .catch(error => handleErrors(error))
}

export function fetchCategories() {
    return [{
        "id": 1,
        "name": "Historija u javnosti",
        "subcategories": [{
            "id": 1,
            "name": "Događaji"
        }, {
            "id": 2,
            "name": "Naučne manifestacije"
        }, {
            "id": 3,
            "name": "Intervju"
        }]
    }, {
        "id": 2,
        "name": "Recenzije",
        "subcategories": [{
            "id": 4,
            "name": "Svijet"
        }, {
            "id": 5,
            "name": "Jugoistočna Evropa"
        }, {
            "id": 6,
            "name": "Bosna i Hercegovina"
        }]
    }, {
        "id": 3,
        "name": "Knjige",
        "subcategories": [{
            "id": 7,
            "name": "Svijet"
        }, {
            "id": 8,
            "name": "Jugoistočna Evropa"
        }, {
            "id": 9,
            "name": "Bosna i Hercegovina"
        }]
    }, {
        "id": 4,
        "name": "Časopisi",
        "subcategories": [{
            "id": 10,
            "name": "Svijet"
        }, {
            "id": 11,
            "name": "Jugoistočna Evropa"
        }, {
            "id": 12,
            "name": "Bosna i Hercegovina"
        }]
    }, {
        "id": 5,
        "name": "Članci i polemike",
        "subcategories": []
    },
    {
        "id": 6,
        "name": "Promo",
        "subcategories": []
    }
    ];
}

/**
 * Processes a single article to add its category name.
 */
export function addCategoryNameToArticle(categories, article) {
    if (!article || !categories) return article || null;
    const category = categories.find(cat => cat.id === article.categoryId);
    return {
        ...article,
        categoryName: category?.name
    };
}

/**
 * Processes an array of articles by reusing the single-item logic.
 */
export function addCategoryNamesToArticles(categories, articles) {
    if (!articles || !categories) return articles || null;
    return articles.map(article => addCategoryNameToArticle(categories, article));
}

export async function loadArticles(cursor, direction, categoryId, subCategoryId, keyword=null, authorUrl=null) {
    // Request for all articles
    let pathQuery = "articles?limit=" + encodeURIComponent(parseInt(NUMBER_OF_ARTICLES_ON_PAGE)) + "&direction=" + encodeURIComponent(direction)
    
    // Add parameters for filtering if they are sent
    if (cursor) pathQuery += "&cursor=" + encodeURIComponent(cursor)
    if (categoryId) pathQuery += "&categoryId=" + encodeURIComponent(categoryId)
    if (subCategoryId) pathQuery += "&subcategoryId=" + encodeURIComponent(subCategoryId)
    if (keyword) {
        pathQuery += "&keyword=" + encodeURIComponent(keyword)
    } 
    if (authorUrl) pathQuery += "&authorUrl=" + encodeURIComponent(authorUrl)

    return addAuthorizationToHeaders({})
        .then(async headers => {
            return noRefreshClient.get(pathQuery, {headers})
                .then(data => {
                    return data.data
                })
                .catch(error => Promise.reject(error))
        })
}

export async function getArticle(articleId) {
    return addAuthorizationToHeaders({})
    .then(async headers => {
        return noRefreshClient.get("articles/" + articleId, {headers})
        .then(data => {
            return data.data
        })
        .catch(error => Promise.reject(error))
    })
}

export async function getArticleByUrl(url) {
    return addAuthorizationToHeaders({})
    .then(async headers => {
        return noRefreshClient.get("articles/url?url=" + encodeURIComponent(url), {headers})
        .then(data => {
            return data.data
        })
        .catch(error => Promise.reject(error))
    })
}

export async function fetchRelatedArticles (value, callback) {
    let currentValue = value
    if (currentValue && currentValue.length > 2) {
        return addAuthorizationToHeaders({})
            .then(headers => {
                if (currentValue && currentValue.length > 2) {
                    return refreshClient.get("articles?keyword=" + encodeURIComponent(value), {headers})
                        .then(data => data.data)
                        .then(data => handleSuccessFetchRelatedArticles(data, currentValue, value, callback))
                        .catch(error => handleErrors(error)
                                        .then(data => data)
                                        .then(data => handleSuccessFetchRelatedArticles(data, currentValue, value, callback))
                                        .catch(err => Promise.reject(err))    
                        )
                }
            })   
    }
}

function handleSuccessFetchRelatedArticles(receivedData, currentValue, value, callback) {
    if (currentValue === value) {
        // the input is still the same - user has not typed anything new
        const content = receivedData.content
        const relatedArticles = content.length > 0 ? content.map((relatedArticle) => ({
            value: relatedArticle.id,
            text: relatedArticle.title
        })) : content
        return callback(relatedArticles)
    }
}

